import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt)

import { provideAnimations } from '@angular/platform-browser/animations';
import { PoModule } from '@po-ui/ng-components';
import { PoStorageModule } from '@po-ui/ng-storage';
import { TCommonApiModule } from '@totvs/common-api';
import { registerLocaleData } from '@angular/common';
import { TotvsTokenInterceptor } from './modules/tesouraria/services/totvs-token.interceptor';


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([TotvsTokenInterceptor]),
      withInterceptorsFromDi()
    ),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(
      PoModule,
      PoStorageModule.forRoot({
        name: 'financeiroStorage',
        storeName: '_finStorage',
        driverOrder: ['lokijs', 'websql', 'indexeddb', 'localstorage']
      }),
      TCommonApiModule,
    )
  ],
};
